import React, { Component } from "react";
import { Wrapper, Animation } from "app/NativeComponents/common";

import SideBarButton from "./SideBarButton";

import { displayIntercom, openUrl } from "app/NativeActions";

class HelpButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: false
    };
  }

  renderDropdownButtons() {
    if (this.state.opened && this.props.mobile_toggle_drawer) {
      return (
        <Animation type="fadeIn">
          <SideBarButton
            {...this.props}
            id={"intercom_button"}
            active={false}
            dropButton={true}
            title="Support"
            icon="live_help"
            onPress={() => {
              if (
                this.props.track_route == true &&
                this.state.intercom_opened == false &&
                this.props.platform == "android"
              ) {
                this.props.toggleActionSheet(null);
                this.props.setModal({
                  title: "Are you sure you want to continue?",
                  description:
                    "This may cause Driving Routes to slow down or even crash",
                  icon: "error",
                  submit: "Continue",
                  onPress: () => {
                    displayIntercom();
                  },
                  cancel: "Nevermind.",
                  onCancel: () => {}
                });
                this.props.toggleModal({ show: true, type: "normal" });
                this.setState({ intercom_opened: true });
              } else {
                displayIntercom();
              }
            }}
            hideButton={false}
          />
          <SideBarButton
            to="https://www.youtube.com/c/DealMachine/playlists"
            active={false}
            dropButton={true}
            title="Instructional Videos"
            icon={"video_library"}
            onPress={() => {
              openUrl("https://www.youtube.com/c/DealMachine/playlists");
            }}
            hideButton={false}
            mobile_toggle_drawer={this.props.mobile_toggle_drawer}
            colors={this.props.colors}
          />
        </Animation>
      );
    }
  }

  render() {
    return (
      <Wrapper>
        <SideBarButton
          {...this.props}
          active={"help" == this.props.tab ? true : false}
          title="Help"
          dropParent={true}
          opened={this.state.opened}
          icon="help"
          onPress={() => {
            this.props.mobileToggleDrawer(true);
            if (this.state.opened) {
              this.setState({ opened: false });
            } else {
              this.setState({ opened: true });
            }
          }}
          hideButton={false}
          mobile_toggle_drawer={this.props.mobile_toggle_drawer}
          colors={this.props.colors}
        />

        {this.renderDropdownButtons()}
      </Wrapper>
    );
  }
}

export default HelpButton;
